/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const IconChevronTop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M7.47 5.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8 7.06l-3.47 3.47a.75.75 0 1 1-1.06-1.06z'
      clipRule='evenodd'
    />
  </svg>
)
